import { Button, CircularProgress } from '@material-ui/core';

interface CustomExportProps {
  onClickDownload: () => void;
  exportLoading: boolean;
  disabled?: boolean;
}

export const CustomExport = ({ onClickDownload, exportLoading, disabled }: CustomExportProps) => {
  return (
    <Button
      variant={'text'}
      disabled={exportLoading || disabled}
      onClick={() => onClickDownload()}
      style={{
        minWidth: '42px',
        minHeight: '42px',
        padding: '6px 8px',
        marginRight: '4px',
      }}
    >
      {exportLoading ? (
        <CircularProgress color="secondary" size={24} thickness={4} style={{ padding: 2, height: '-1px' }} />
      ) : (
        <i className="material-icons-outlined" style={{ fontSize: 26 }}>
          download
        </i>
      )}
    </Button>
  );
};
